import Grid from '@material-ui/core/Grid';

import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';
import { useSelector } from 'react-redux';

import { baseTheme } from '../../../theme';
import GroupPostResult from '../group-post-result';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
      maxHeight: '600px',
      overflowY: 'scroll',
    },
    noResults: {
      padding: theme.spacing(1),
    },
  }),
);

export default function GroupPostList(props: any) {
  const { id, leader, allowedAccess, groupType } = props;
  const classes = useStyles(baseTheme);
  const followed = useSelector((state: any) => state.leaders.follow);

  const posts = followed.length && followed
    .filter((item: any) => item.leader.id === leader.id)
    .map((item: any) => item.groups.filter((group: any) => group.id === id))
    .map((item: any) => item[0].posts)
    .reduce((arr: any, item: any) => {
      return item;
    }, []);

  return (
    <Grid
      item
      container
      className={`${classes.root}`}>
      {posts?.length
        ? posts.map((result: any) =>
          <GroupPostResult post={result} leader={leader} groupType={groupType} />)
        : allowedAccess ?
          (<div className={classes.noResults}>No Posts found for this group</div>)
          : (<div className={classes.noResults}>
            You do not have permission to this group yet.
          </div>)}
    </Grid>
  );
}
